module.exports = __webpack_public_path__ + "img/Realisme_Kunsten_og_moderniteten2.afe1991e.jpg";